<template>
<a-spin v-if="!EnterpriseId" style="display:block;"/>
<div :style="isLeft?'height:100%;':'width:100%;'" v-else>
    <div :class="nowClass">
        <div v-if="tag && !imgError" class="img" :style="{background:`url(${iconUrl}) center center no-repeat`,backgroundSize:coverNow}"/>
        <div v-else class="img default"/>
        <img v-show="false" :src="iconUrl" @error="loadDefault()"/>
    </div>
</div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      imgError:false,
    };
  },
  inject:['toUri'],
  props:{
      tag:{
          //item.icon和拿有名字的图片
          type:String,
          default:()=>{
              return null
          }
      },
      size:{
          type:String,
          default:()=>{
              return 's5'
          }
      },
      nowUrI:{
          type:String,
          default:()=>{
              return null
          }
      },
      needTagImg:{
          type:Boolean,
          default:()=>{
              return false
          }
      },
      isLeft:{
          type:Boolean,
          default:()=>{
              return true
          }
      },
      isCover:{
          type:Boolean,
          default:()=>{
              return false
          }
      }
  },
  mounted(){
      
  },
  methods: {
      loadDefault(){
        this.imgError = true;
      },
      getStoreImg(){
        let tags = this.tag.split("-");
        let str = this.tag;
        if(parseInt(tags[0])>=0){
            str = str.replace(tags[0]+'-','');
        }
        let userInfo = this.$store.getters.getUserInfo;
        if(userInfo&&userInfo.enterprise){
          return location.origin + "/infoplus/file/enterprise/" + userInfo.enterprise.id + "/icon/" + str;
        }else{
          return ''
        }
      }, 
  },
  computed:{
    EnterpriseId(){
      if(this.$store.getters.getUserInfo&&this.$store.getters.getUserInfo.enterprise){
          return  this.$store.getters.getUserInfo.enterprise.id;
      }else{
          return '';
      }
    },
    iconUrl(){
        return this.needTagImg?this.getStoreImg():this.tag;
    },
    nowClass(){
        return !this.needTagImg?`${this.size} defaultIcon`:`${this.size} defaultIcon tag`;
    },
    coverNow(){
        return this.isCover?'cover !important':'contain !important';
    }
  }
};
</script>
<style scoped>
.defaultIcon{
    display:block;
    overflow:hidden;
    height:70%;
    width:100%;
}
.defaultIcon.s3{	
	height: 35%;
	
}
.defaultIcon.s4{	
	height: 45%;
}
.defaultIcon.s5{	
	height: 55%;
}
.defaultIcon.s6{	
	height: 65%;
}
.defaultIcon.s7{	
	height: 75%;
}
.defaultIcon.s8{	
	height: 85%;
}
.defaultIcon.s9{	
	height: 95%;
}
.defaultIcon.s10{	
	height: 100%;
}
.defaultIcon .img.default{	
    /*此处请勿改动路径，直接在assets/images里定义一张默认图片*/
	background-image: url('../../assets/images/app_default_img.png');
	background-position: center center;
	background-repeat:no-repeat;
	background-size: contain;
}
.defaultIcon.tag .img.default{	
    /*此处请勿改动路径，直接在assets/images里定义一张默认图片*/
	background-image: url('../../assets/images/app_tag_default.png');
	background-position: center center;
	background-repeat:no-repeat;
	background-size: contain;
}
.defaultIcon .img{
    display:block;
    height:100%;
    background-size:contain !important;
}
</style>


// WEBPACK FOOTER //
// src/components/todoCenter/defaultIcon.vue